import { Box } from "@chakra-ui/react";
import React from "react";

const ListAccordionView = ({
  isExperientialLearning,
  isCustomAssessment,
  subTopicTaskProgress,
  isMobile,
  isSideNav,
}) => {
  // let isSmallMobile = window.innerWidth < 414;
  return (
    <Box
      margin={
        isMobile
          ? "12px 0px 0px 8px"
          : // ? isSmallMobile
            //   ? "12px 0px 0px 8px"
            //   : "16px 0px 0px 8px"
            "0px 0px 0px 8px"
      }
    >
      {Array.from({
        length:
          isExperientialLearning || isCustomAssessment
            ? 0
            : subTopicTaskProgress?.length,
      }).map((_, index) => {
        let taskStatus = subTopicTaskProgress[index]?.taskStatus;
        let bgColorr =
          taskStatus === "inProgress"
            ? "#F59E0B"
            : taskStatus === "completed"
            ? "#79BA40"
            : "grey";
        return (
          <>
            <Box
              width="8px"
              height="8px"
              borderRadius="50%"
              bgColor={bgColorr}
            />
            {index <
              (isExperientialLearning || isCustomAssessment
                ? 0
                : subTopicTaskProgress?.length - 1) && (
              <Box
                width="2px"
                height={
                  isMobile && !isSideNav ? "48px" : isSideNav ? "54px" : "25px"
                }
                borderRadius="2px"
                bgColor="#6D6BAE"
                margin="2px auto"
              />
            )}
          </>
        );
      })}
    </Box>
  );
};

export default React.memo(ListAccordionView);
